import { ApFeedResponse, ApProduct, DiscoverProviderResponse, FtpFeedResponse, WireCredentials, WireFeed } from '@discover/store/models/feed.provider.models';
import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { WireFeedTypes } from '@src/suite/common/enums/wire-feed-types';

export const FeedProviderActions = createActionGroup({
    source: 'Feed provider',
    events: {
        'Init dialog': emptyProps(),
        'Init feeds': emptyProps(),

        'Reset dialog': emptyProps(),

        'Open add credentials dialog': emptyProps(),
        'Open edit credentials dialog': props<{ credentials: WireCredentials }>(),

        'Open add feed dialog': emptyProps(),
        'Open edit feed dialog': props<{ feed: WireFeed }>(),

        'Update credentials title': props<{ credTitle: string }>(),
        'Update credentials type': props<{ credType: WireFeedTypes }>(),
        'Update credentials api key': props<{ apiKey: string }>(),
        'Save wire credentials': emptyProps(),

        'Update feed title': props<{ feedTitle: string }>(),
        'Update feed type': props<{ feedType: WireFeedTypes }>(),

        'Update ftp provider': props<{ ftpProvider: string }>(),
        'Update ftp url': props<{ ftpUrl: string }>(),
        'Update ftp username': props<{ ftpUsername: string }>(),
        'Update ftp password': props<{ ftpPassword: string }>(),
        'Update ftp directory': props<{ ftpDirectory: string }>(),

        'Update ap credentails id': props<{ apCredentialsId: string }>(),
        'Update selected products': props<{ products: Array<string> }>(),

        'Save wire feed': emptyProps(),
        'Edit wire feed': props<{ feedId: string; feedType: WireFeedTypes; credentialsId: string }>(),
    },
});

export const FeedProviderApiActions = createActionGroup({
    source: 'Feed provider API',
    events: {
        'Get credentials and feeds': emptyProps(),
        'Get credentials and feeds success': props<{ credentials: Array<WireCredentials>; feeds: Array<WireFeed> }>(),
        'Get credentials and feeds error': props<{ error: string }>(),

        'Get wire credentials': props<{ credentialsType: WireFeedTypes; credentialsId?: string }>(),
        'Get wire credentials success': props<{ credentials: WireCredentials }>(),
        'Get wire credentials error': props<{ error: string }>(),

        'Create wire credentials': emptyProps(),
        'Create wire credentials success': props<{ credentials: WireCredentials }>(),
        'Create wire credentials error': props<{ error: string }>(),

        'Update wire credentials': emptyProps(),
        'Update wire credentials success': props<{ credentials: WireCredentials }>(),
        'Update wire credentials error': props<{ error: string }>(),

        'Delete credentials': props<{ guid: string; ftype: WireFeedTypes }>(),
        'Delete credentials success': emptyProps(),
        'Delete credentials error': props<{ error: string }>(),

        'Get providers': emptyProps(),
        'Get providers success': props<{ providers: Array<DiscoverProviderResponse> }>(),
        'Get providers error': props<{ error: string }>(),

        'Create FTP feed': props<{ credentialsId: string }>(),
        'Create FTP feed success': props<{ feed: FtpFeedResponse }>(),
        'Create FTP feed error': props<{ error: string }>(),

        'Update FTP feed': emptyProps,
        'Update FTP feed success': props<{ feed: FtpFeedResponse }>(),
        'Update FTP feed error': props<{ error: string }>(),

        'Get FTP feed': props<{ feedId: string }>(),
        'Get FTP feed success': props<{ feed: FtpFeedResponse }>(),
        'Get FTP feed error': props<{ error: string }>(),

        'Create AP feed': emptyProps(),
        'Create AP feed success': props<{ feed: ApFeedResponse }>(),
        'Create AP feed error': props<{ error: string }>(),

        'Update AP feed': emptyProps(),
        'Update AP feed success': props<{ feed: ApFeedResponse }>(),
        'Update AP feed error': props<{ error: string }>(),

        'Get AP feed': props<{ feedId: string }>(),
        'Get AP feed success': props<{ feed: ApFeedResponse }>(),
        'Get AP feed error': props<{ error: string }>(),

        'Delete feed': props<{ feedId: string; feedType: WireFeedTypes }>(),

        'Delete AP feed': props<{ feedId: string }>(),
        'Delete AP feed success': props<{ feed: ApFeedResponse }>(),
        'Delete AP feed error': props<{ error: string }>(),

        'Delete ftp feed': props<{ feedId: string }>(),
        'Delete ftp feed success': props<{ feed: FtpFeedResponse }>(),
        'Delete ftp feed error': props<{ error: string }>(),

        /* ---------------------- */
        /*
        'Get access tokens': emptyProps(),
        'Get access tokens success': props<{ tokens: Array<AccessToken> }>(),
        'Get access tokens error': props<{ error: string }>(),

        'Get wire feeds': emptyProps(),
        'Get wire feeds success': props<{ feeds: Array<WireFeed> }>(),
        'Get wire feeds error': props<{ error: string }>(),
*/
        'Get AP feed products': props<{ id: string }>(),
        'Get AP feed products success': props<{ products: Array<ApProduct> }>(),
        'Get AP feed products error': props<{ error: string }>(),
    },
});
